import { AxiosResponse } from 'axios';

import { APResponse } from '@qality/common-model/src/AP/AP';

import API from './API';

export default {
  updateAppProperty(
    propertyKey: string,
    data: unknown
  ): Promise<AxiosResponse | APResponse> {
    return API.request({
      url: `/rest/atlassian-connect/1/addons/${plugin.addonKey}/properties/${propertyKey}`,
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify(data),
    });
  },

  deleteAppProperty(propertyKey: string): Promise<AxiosResponse | APResponse> {
    return API.request({
      url: `/rest/atlassian-connect/1/addons/${plugin.addonKey}/properties/${propertyKey}`,
      type: 'DELETE',
    });
  },

  getAppProperty(propertyKey: string): Promise<AxiosResponse | APResponse> {
    return API.request({
      url: `/rest/atlassian-connect/1/addons/${plugin.addonKey}/properties/${propertyKey}`,
      type: 'GET',
    });
  },

  getAppPropertyNoRetry(
    propertyKey: string
  ): Promise<AxiosResponse | APResponse> {
    return API.noRetry({
      url: `/rest/atlassian-connect/1/addons/${plugin.addonKey}/properties/${propertyKey}`,
      type: 'GET',
    });
  },
};
